import { getSeo } from '@Utils/cms';
import { jsonToHTML } from '@Utils/cms-rte';
import {
  adapterEditoHeader,
  adapterEditoNav,
  adapterMediaBlock,
} from '@Adapters/cms/edito.adapter';
import { adapterBannerApp } from '@Adapters/cms/app.adapter';
import { adapterServiceList } from '@Adapters/cms/services.adapter';

function adapterQrCode(data) {
  if (!data) {
    return undefined;
  }

  const { qrcode_text: text } = data;
  const img = data.qrcode_image?.url;

  if (!img || !text) {
    return undefined;
  }

  return {
    img,
    text,
  };
}

function adapterMealIdeas(cmsData, context) {
  if (!cmsData?.length) {
    return undefined;
  }

  const [data] = cmsData || [];
  if (!data) {
    return undefined;
  }

  const navigation = adapterEditoNav(data, context);
  const header = adapterEditoHeader({
    ...data.page_title_block,
    text: data.text_1,
  });
  const headerVideo = data.video_1?.url;
  const editoPush = adapterQrCode(data);
  const mediaBlock = adapterMediaBlock(data.media_block?.[0], context);

  let editoMedia;
  const video = data.video_2?.url;
  let videoText = jsonToHTML(data.text_2);
  if (videoText) {
    videoText = {
      content: videoText,
    };
  }
  if (videoText || video) {
    editoMedia = {
      intro: videoText,
      video,
    };
  }

  let footnotes = jsonToHTML(data.footer);
  if (footnotes) {
    footnotes = {
      content: footnotes,
    };
  }

  const bannerApp = adapterBannerApp(data.banner_app);
  const serviceList = adapterServiceList(data.edito_pages_cards, context);

  return {
    bannerApp,
    editoMedia,
    editoPush,
    footnotes,
    header,
    headerVideo,
    mediaBlock,
    navigation,
    serviceList,
    seo: getSeo(data),
  };
}

export { adapterMealIdeas, adapterQrCode };
